import React from 'react';
import { AlertTriangle } from 'lucide-react';

const DefectsSummaryCard = ({ stats }) => {
  const activeCount = stats.active || 0;
  const criticalCount = stats.critical || 0;
  const highCount = stats.high || 0;
  const mediumCount = stats.medium || 0;
  const lowCount = stats.low || 0;
  const resolvedCount = stats.resolved || 0;
  const totalCount = stats.total || 0;

  // FT-90: Penalty model for defect compliance
  // Critical = -100%, High = -20%, Medium = -5%, Low = 0%
  // Formula: MAX(0, 100 - sum_of_penalties)
  // Only ACTIVE (unresolved) defects apply penalties
  // This matches MCA/ISM standards where defects directly impact operational readiness
  const totalPenalty = (criticalCount * 100) + (highCount * 20) + (mediumCount * 5) + (lowCount * 0);
  const compliancePercentage = Math.max(0, 100 - totalPenalty);

  return (
    <div className="rounded-2xl border border-gray-200 shadow-sm bg-white overflow-hidden">
      {/* Header */}
      <div className="bg-slate-700 px-5 py-3">
        <div className="flex items-center gap-2">
          <AlertTriangle className="h-5 w-5 text-white" />
          <h3 className="text-base font-semibold text-white">Defect Summary</h3>
        </div>
      </div>

      {/* Content Section */}
      <div className="px-6 py-5">
      {/* Compliance Bar */}
      <div className="mb-4">
        <div className="flex items-center justify-between mb-1">
          <span className="text-sm text-gray-600">Compliance Status</span>
          <span className="text-sm font-semibold text-gray-900">{compliancePercentage}%</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div
            className={`h-2 rounded-full transition-all duration-300 ${
              compliancePercentage >= 80 ? 'bg-green-600' :
              compliancePercentage >= 50 ? 'bg-amber-500' : 'bg-red-600'
            }`}
            style={{ width: `${compliancePercentage}%` }}
          />
        </div>
      </div>

      {/* Status Counts */}
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
            <span className="text-sm text-gray-600">Active</span>
          </div>
          <span className="text-sm font-semibold text-orange-600">{activeCount}</span>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 bg-red-500 rounded-full"></div>
            <span className="text-sm text-gray-600">Critical</span>
          </div>
          <span className="text-sm font-semibold text-red-600">{criticalCount}</span>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
            <span className="text-sm text-gray-600">Resolved</span>
          </div>
          <span className="text-sm font-semibold text-green-600">{resolvedCount}</span>
        </div>
      </div>

      {/* Total */}
      <div className="mt-4 pt-4 border-t border-gray-200">
        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-600">Total</span>
          <span className="text-sm font-semibold text-gray-900">{totalCount} defects</span>
        </div>
      </div>
      </div>
    </div>
  );
};

export default DefectsSummaryCard;
